export default [
  {
    title: '考核月份',
    key: 'reportTime',
    width: 60
  },
  {
    title: '素材ID',
    key: 'imageId',
    width: 48
  },
  {
    title: '素材名称',
    key: 'imageName',
    width: 140,
    overflow: true
  },
  {
    title: '素材类型',
    key: 'imageType',
    width: 60
  },
  {
    title: '设计人员',
    type: 'basic',
    key: 'designerName'
  },
  {
    title: '策划人',
    overflow: true,
    type: 'basic',
    key: 'plannerName'
  },
  {
    title: '原画',
    overflow: true,
    type: 'basic',
    key: 'paintingName'
  },
  {
    title: '渲染',
    overflow: true,
    type: 'basic',
    key: 'renderName'
  },
  {
    title: '模型地编',
    overflow: true,
    type: 'basic',
    key: 'tcmName'
  },
  {
    title: '动画',
    overflow: true,
    type: 'basic',
    key: 'animationName'
  },
  {
    title: '一级素材样式',
    type: 'basic',
    key: 'imageStyle1LabelNames',
    width: 100
  },
  {
    title: '二级素材样式',
    type: 'basic',
    key: 'imageStyle2LabelNames',
    width: 100
  },
  {
    title: '游戏',
    key: 'gameNames',
    type: 'basic',
    width: 104
  },
  {
    title: '上传时间',
    key: 'imageCreateTime',
    type: 'basic',
    width: 74
  },
  {
    title: '消耗计算起始日',
    key: 'imageLauchTime',
    type: 'basic',
    width: 100
  },
  {
    title: '30日实际消耗金额',
    key: 'thirtyDaysAmount',
    sortable: 'custom',
    type: 'basic',
    width: 130
  },
  {
    title: '项目组奖金',
    sortable: 'custom',
    type: 'basic',
    key: 'projectBonus',
    width: 110
  },
  {
    title: '设计中台奖金',
    sortable: 'custom',
    type: 'basic',
    key: 'designBonus',
    width: 110
  },
  {
    title: '总奖金',
    sortable: 'custom',
    type: 'basic',
    key: 'bonus'
  },
  {
    title: '操作',
    key: 'control',
    width: 80
  }
]
